var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"text-caption font-italic font-weight-light pa-0",staticStyle:{"height":"auto","line-height":"1rem !important","color":"inherit"}},[_vm._v(_vm._s(_vm.computedText))])}
var staticRenderFns = []

export { render, staticRenderFns }